import module from 'nominas/sumario/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('nominas.agregar', {
    url: '/agregar?{proyecto_id}&{nomina_id}',
    params: {idProyectos: {array: true}},
    data: {title: 'Nóminas'},
    views: {
      '@': {
        template: '<nominas-sumario-agregar proyecto-id="proyectoId" nomina-id="nominaId"></nominas-sumario-agregar>',
        controller: ($scope, proyectoId, nominaId) => {
          $scope.proyectoId = proyectoId
          $scope.nominaId = nominaId
        },
      },
    },
    resolve: {
      proyectoId: ($stateParams) => $stateParams.proyecto_id,
      nominaId: ($stateParams) => $stateParams.nomina_id,
    },
  })
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/routes/sumarioAgregar.js